import {BaseLinkParams} from "../../../../infrastructure/models/link/base-link-params";
import {BaseHashParamsModel} from "./base-hash-params-model";
import {Type} from "../../../../infrastructure/type";

export class BaseMatchModel {
  params: BaseLinkParams;
  path: String;
  url: String;
  hashParams: BaseHashParamsModel;

  constructor(params: Object, path: String, url: String, hash: String, parent) {
    this.params = params;
    this.path = path;
    this.url = url;
    this.hashParams = this.resolveHashParams(hash);
    this.parent = parent;
  }

  get hashParamsModel(): Type<BaseHashParamsModel> {
    return BaseHashParamsModel;
  }

  equals(model: BaseMatchModel): Boolean {
    let equals = true;

    equals &= this.path === model.path;
    equals &= this.url === model.url;
    equals &= this.params === model.params;
    equals &= this.hashParams?.toString() === model.hashParams?.toString();

    return equals;
  }

  resolveHashParams(hash): BaseHashParamsModel {
    let hashParams: Object = {};

    if (hash) {
      const hashParamsArray = hash.replace('#', '').split('&');
      hashParamsArray?.forEach((param) => {
        if (param.includes('=')) {
          const paramName: String = param.split('=')[0];
          const paramValue: String = param.split('=')[1];

          hashParams[paramName] = paramValue;
        } else {
          hashParams[param] = param;
        }
      })
    }

    return new this.hashParamsModel(hashParams);
  }
}
